var map = {
	"./de/global.json": 37801,
	"./en/global.json": 13469,
	"./es/global.json": 61312,
	"./fr/global.json": 10664,
	"./id/global.json": 64715,
	"./ja/global.json": 52815,
	"./nl/global.json": 29798,
	"./pt/global.json": 1932,
	"./zh/global.json": 84286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9007;